module.exports = "<a class=\"btn btn-outlined-new secondary hidden-print\" ng-href=\"/export_to_pdf?url={{vm.exportUrl}}\" target=_blank><i class=\"fa fa-file-pdf-o\"></i> {{'pdf_export' | translate}}</a> ";


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/app/components/cn-pdf-export/cn-pdf-export.html
 ** module id = 54
 ** module chunks = 0
 **/